module.exports = __webpack_public_path__ + "static/media/eventPageImage.a73ab1bf.svg";